import { render, staticRenderFns } from "./SuratKontrol.vue?vue&type=template&id=77844bbc&"
import script from "./SuratKontrol.vue?vue&type=script&lang=js&"
export * from "./SuratKontrol.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports